// import {createApp} from 'vue';
import Main from './Main';

// eslint-disable-next-line no-undef
const createApp = typeof Vue !== 'undefined' ? Vue.createApp : null;

if (createApp) {
	const App = createApp({
			components: {
				'ubfdl-main': Main,
			},
			mounted: function () {
				console.log('ubfdl mounted.');
			}
		}
	);

	window.addEventListener('load', () => {
		App.mount('main');
	});
}

